import React, { useEffect } from 'react'
import { Flex } from 'pcln-design-system'

const InlineAd = ({ gaIndex, adId, className }) => {
  useEffect(() => {
    window?.PCLN?.pclnEventDispatcher?.dispatch('AIR_MOBILE_ADS', [adId])
  }, [adId])
  return (
    <li className='ad' data-testid='inline-ad' data-ga-index={gaIndex} key={adId}>
      <section>
        <Flex justifyContent='center' className='pcln-gpt-dart-ad'>
          <div className={className} id={adId} data-testid={className} />
        </Flex>
      </section>
    </li>
  )
}

export { InlineAd }
